@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">WhatsApp (Instância)</div>
    </div>
    <div class="pt-3 pr-4 pb-0 pl-4">
      @if (canaisComunicacaoWhatsAppQRCode != null) {
        @if (canaisComunicacaoWhatsAppQRCode.connected) {
          <div class="d-flex justify-content-center">
            <div>
              <b>WhatsApp conectado com sucesso!</b>
            </div>
          </div>
        }
        @if (canaisComunicacaoWhatsAppQRCode.value != null) {
          <div class="subtitulo mt-2 mb-2">Conectar-se ao WhatsApp</div>
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column">
              <div class="pt-2">
                Para que ocorra o envio/recebimento de mensagens via <b>WhatsApp</b> basta seguir os seguintes passos:
              </div>
              <div class="pt-2">
                1. Abra o WhatsApp no seu telefone;
              </div>
              <div>
                2. Toque em Menu <i class="fa fa-ellipsis-v pl-2 pr-2"></i> e selecione <b>Aparelhos conectados</b>;
              </div>
              <div>
                3. Toque em <b>Conectar um aparelho</b>;
              </div>
              <div>
                4. Aponte seu telefone para esta tela para capturar o QR-Code.
              </div>
            </div>
            <div class="p-4">
              <img [src]="canaisComunicacaoWhatsAppQRCode.value" alt="QRCode" />
            </div>
          </div>
        }
      }
    </div>
  </div>
}
